var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("figure", { staticClass: "content-hiv-info-graphic" }, [
    _c("div", { staticClass: "aspect-ratio-box" }, [
      _c("div", { staticClass: "aspect-ratio-box-inner" }, [
        _c("div", { staticClass: "content-hiv-info-graphic-background" }, [
          _c("div", {
            staticClass:
              "content-hiv-info-graphic-toggle content-hiv-info-graphic-toggle-0",
            on: {
              click: function($event) {
                return _vm.toggleOverlay(0)
              }
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "content-hiv-info-graphic-toggle content-hiv-info-graphic-toggle-1",
            on: {
              click: function($event) {
                return _vm.toggleOverlay(1)
              }
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "content-hiv-info-graphic-toggle content-hiv-info-graphic-toggle-2",
            on: {
              click: function($event) {
                return _vm.toggleOverlay(2)
              }
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "content-hiv-info-graphic-toggle content-hiv-info-graphic-toggle-3",
            on: {
              click: function($event) {
                return _vm.toggleOverlay(3)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "content-hiv-info-graphic-overlay content-hiv-info-graphic-overlay-0",
              style: { opacity: _vm.overlayIndex === 0 ? 1 : 0 }
            },
            [
              _c("h4", [_vm._v("Fusions-Hemmer")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                        auch Eintritts-Hemmer genannt, verhindern entweder das Andocken der Viren auf der Wirtszelle oder\n                        das nachfolgende Eindringen in die Wirtszelle selbst.\n                    "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "content-hiv-info-graphic-overlay content-hiv-info-graphic-overlay-1",
              style: { opacity: _vm.overlayIndex === 1 ? 1 : 0 }
            },
            [
              _c("h4", [_vm._v("Reverse Transkriptase-Hemmer:")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                        Das Virus muss seine Erbinformation – die Virus-RNA – mithilfe des Enzyms Reverse-Transkriptase in\n                        DNA umschreiben. Sonst kann diese nicht in die Erbinformation der Wirtszelle eingebaut werden.\n                        Dieser Umschreibe-Prozess lässt sich medikamentös stören. Diese Medikamente heißen Nukleosidale bzw.\n                        Nukleosidanaloge Reverse-Transkriptase-Hemmer (NRTIs). Am selben Punkt der Virusvermehrung setzen\n                        die Nicht-Nukleosidalen bzw. Nicht-Nukleosidanalogen Reverse-Transkriptase-Hemmer, sogenannte NNRTIs\n                        an. Sie blockieren das Enzym direkt, sodass der Prozess des Umschreibens der Erbinformation\n                        unmittelbar verhindert wird.\n                    "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "content-hiv-info-graphic-overlay content-hiv-info-graphic-overlay-2",
              style: { opacity: _vm.overlayIndex === 2 ? 1 : 0 }
            },
            [
              _c("h4", [_vm._v("Integrase-Inhibitoren")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                        behindern die Virusvermehrung, indem sie den Einbau – die Integration – der neu geschriebenen\n                        Virus-DNA in die menschliche DNA verhindern.\n                    "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "content-hiv-info-graphic-overlay content-hiv-info-graphic-overlay-3",
              style: { opacity: _vm.overlayIndex === 3 ? 1 : 0 }
            },
            [
              _c("h4", [_vm._v("Protease-Hemmer blockieren")]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                        ein virales Enzym, die „Protease“. Auch die Protease hat das HI-Virus mit in die Wirtszelle\n                        gebracht. Wird die Protease gehemmt, können keine neuen HI-Viren entstehen.\n                    "
                )
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd324046", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd324046","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/content/ContentHivInfoGraphic.vue
// module id = 572
// module chunks = 0